"use strict";
import MODES from "../modes";
import { Action } from "../actions";
export default function modesReducer(mode = {
  type: MODES.selectOrMove,
  meta: {}
}, action) {
  switch (action.type) {
    case Action.CHANGE_MODE:
      return {
        type: action.name,
        meta: action.meta
      };
    default:
      return mode;
  }
}
